const getters = {
  token: (state) => state.user.token,
  userInfo: (state) => {
    if (!state?.user?.Info?.id) {
      return JSON.parse(localStorage.getItem('userInfo'))
    }
    return state.user.Info
  },
  codes: (state) => {
    if (!state.common.codes) {
      return JSON.parse(localStorage.getItem('codes'))
    }
    return state.common.codes
  },
}

export default getters
